<template>
  <base-section
    id="theme-features"
  >
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-for="(feature, i) in features"
            :key="i"
            v-bind="feature"
            align="left"
            horizontal
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-img
            src="@/assets/bg.svg"
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({
      features: [
        {
          color: 'green',
          dark: true,
          title: 'World-class support',
          icon: 'mdi-fountain-pen-tip',
          text: 'Partner onboarding, technical training, dedicated account management, and ongoing support for new features and changes..',
        },
        {
          color: 'green',
          dark: true,
          title: 'Marketing promotion and lead generation',
          icon: 'mdi-cellphone',
          text: 'KCS actively works to promote our partners through various marketing initiatives and promotional campaigns. Project leads are then given to our partners.',
        },
        {
          color: 'green',
          dark: true,
          title: 'How to get started',
          icon: 'mdi-pencil-box-outline',
          text: 'KCS actively works to promote our partners through various marketing initiatives and promotional campaigns. Project leads are then given to our partners.',
        },
      ],
    }),
  }
</script>
